<template>
    <v-container>
        <v-layout justify-center wrap style="position: relative">

            <v-flex xs12>
                <w-main-title
                    class="pb-0"
                    title="Agenda"
                    :breadcrumbs="breadcrumbs"
                ></w-main-title>
            </v-flex>

        </v-layout>

        <v-row no-gutters v-if="institutionAccount || allowModifying">
          <v-col cols="12" class="text-right" >
            <v-layout wrap>
              <v-flex v-if="allowModifying" xs12 pa-1 >
                <v-btn :fab="isMobile" class="ma-1" color="secondary"  @click="addSchedule">
                  <v-icon left size="18">far fa-calendar-plus</v-icon>
                  Nueva agenda
                </v-btn>
              </v-flex>
            </v-layout>
          </v-col>
        </v-row>

      <v-row>
        <v-col cols="12"  >
          <v-card class="kim-card" color="secondary-card">
            <v-card-text>
              <v-row justify="center" align="center">

                <v-col cols="12">
                  <v-text-field
                      :disabled="loading || firstLoad"
                      clearable
                      @click:clear="term=''"
                      @keyup.enter="getSchedules"
                      hide-details
                      v-model="term"
                      filled
                      prepend-inner-icon="search"
                      @click:prepend-inner="getSchedules"
                      label="Buscar agenda"
                      :placeholder="searchPlaceholder"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="kim-card mt-2">
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 text-center pt-2>
                  <v-progress-linear class="mt-1" color="primary" height="2" width="1" v-if="loading || firstLoad" indeterminate/>
                  <v-slide-y-transition>
                    <schedule-list
                        :allow-modifying="allowModifying"
                        :individual-mode="individualMode"
                        v-on:select="onScheduleSelect"
                        v-on:activate="onScheduleSetActive"
                        v-on:delete="onScheduleDelete"
                        v-show="!loading && !firstLoad"
                        :items="schedules"
                    />
                  </v-slide-y-transition>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>



        <schedule-form v-on:success="onScheduleSave" ref="scheduleForm"/>
    </v-container>
</template>
<script>

    import WMainTitle from '@/components/common/WMainTitle'
    import ScheduleForm from '@/components/providers/panel/ScheduleForm'
    import ScheduleList from '@/components/providers/panel/ScheduleList'
    import BranchOfficeSelect from '@/components/common/panel/BranchOfficeSelect'

    import {mapMutations, mapState} from 'vuex'
    import {ApiUtils} from '@/utils/ApiUtils'

    export default{
        props: {
            breadcrumbs:{
                type: Array,
                required: true
            },
            allowModifying: {
              type: Boolean,
              default: true
            },
            institutionAccount: {
              type: Boolean,
              default: true
            },
            individualMode: {
              type: Boolean,
              default: false
            },
            searchPlaceholder:{
                type: String,
                default: 'Servicio o Especialista'
            }
        },
        components: {
            WMainTitle,
            ScheduleForm,
            ScheduleList,
            BranchOfficeSelect
        },
        data(){
            return {
                firstLoad: true,
                loading: false,
                lastRequestId: 0,
                term: '',
                schedules: [],
                selectedSchedule: null
            }
        },
        mounted(){
            var vm = this
            vm.getSchedules()
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            onScheduleSave(schedule){
                this.schedules.unshift(schedule)
            },
            addSchedule(){
                var vm = this
                vm.selectedMember = null
                vm.$refs.scheduleForm.show()
            },
            onScheduleSelect(schedule){
                var vm = this
                vm.selectedSchedule = schedule
            },
            onScheduleDelete(scheduleId){
                var vm = this
                const foundIndex = vm.schedules.findIndex(schedule => schedule.id === scheduleId)
                if(foundIndex !== -1) {
                    vm.schedules.splice(foundIndex, 1)
                }
            },
            onScheduleSetActive(updatedSchedule){
                var vm = this
                const updatedIndex = vm.schedules.findIndex(schedule => schedule.id === updatedSchedule.id)
                if(updatedIndex === -1) return
                vm.$set(vm.schedules, updatedIndex, {
                    ...vm.schedules[updatedIndex],
                    active: updatedSchedule.active
                })
            },
            async getSchedules(){

                var vm = this

                if (!vm.currentProvider || (
                    vm.institutionAccount &&
                    !vm.currentBranchOffice
                )) {
                    return
                }

                const requestId = ++vm.lastRequestId

                vm.loading = true
                const url = vm.institutionAccount ?
                        `provider/${vm.currentProvider.id}/branch-office/${vm.currentBranchOffice.id}/schedules` :
                        `provider/${vm.currentProvider.id}/schedules`

                var filters = {
                    term: vm.term
                }

                if(vm.individualMode && vm.institutionAccount){
                    filters.specialist_id = vm.currentUser.id
                }

                var response = await ApiUtils.makeGet(url, filters)

                if(requestId !== vm.lastRequestId) return

                vm.loading = false

                if (!response.ok) {
                    const json = await response.json()
                    vm.schedules = [];
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando consultar agendas')
                    return
                }

                const json = await response.json()
                vm.schedules = json.result.schedules.data

            }
        },
        computed: {
            ...mapState(['currentUser', 'currentProvider', 'currentBranchOffice'])
        },
        watch: {
            term(val){
                if(!val) this.getSchedules()
            },
            loading(val){
                if(!val){
                    this.firstLoad = false
                }
            },
            currentBranchOffice(val){
                if (val) {
                    this.getSchedules()
                }
            }

        }
    }
</script>

<style scoped>
    .picker-wrapper {
        position: absolute;
        top: 5px;
        right: 0px;
        max-width: 230px;
    }
</style>
